<div class="download-app">
  <div class="download-app-container">
    <div class="download-app-links">
      <div class="typography typography-h2 typography-bold">
        Скачать приложение
      </div>
      <div class="typography typography-h2 typography-bold green-basic mb-36">
        Helix Express
      </div>
      <app-mobile-apps-links
        class="pb-72"
        [googlePlayLink]="HelixExpressMobileApp.autodetectStoreLinkExpress"
        [appleStoreLink]="HelixExpressMobileApp.autodetectStoreLinkExpress"
        [appGalleryLink]="''"
      >
      </app-mobile-apps-links>
    </div>
    <img [src]="images.downloadApp" alt="" />
  </div>
</div>
